// @mui/icons-material
import React, { Suspense, Fragment, lazy } from "react";
import { Switch, Route } from "react-router-dom";
import {LoadingScreen} from "./components";
import AuthGuard from "./Common/AuthGuard";
import GuestGuard from "./Common/GuestGuard";
import Layout from "../src/layouts";

export const renderRoutes = (routes = []) => (
  <Suspense fallback={<LoadingScreen />}>
    <Switch>
      {routes.map((route, i) => {
        const Guard = route.guard || Fragment;
        const Layout = route.layout || Fragment;
        const Component = route.component;

        return (
          <Route
            key={i}
            title={route.title}
            path={route.path}
            exact={route.exact}
            render={(props) => (
              <Guard>
                <Layout>
                  {route.routes ? (
                    renderRoutes(route.routes)
                  ) : (
                    <Component {...props} />
                  )}
                </Layout>
              </Guard>
            )}
          />
        );
      })}
    </Switch>
  </Suspense>
);

const routes = [
  {
    exact: true,
    path: "/404",
    component: lazy(() => import("./views/Errors/NotFoundView")),
    
  },
  {
    exact: true,
    guard: GuestGuard,
    path: "/",
    component: lazy(() => import("./views/Login")),
  },
  {
    exact: true,
    path: "/gracias",
    component: lazy(() => import("./views/DataFast")),
  },
  {
    exact: true,
    path: "/documentos/terminos",
    component: lazy(() => import("./views/Document/terminos/Index")),
  },
  {
    exact: true,
    path: "/documentos/politicas",
    component: lazy(() => import("./views/Document/politicas/Index")),
  },
  {
    path: "/administrador",
    guard: AuthGuard,
    layout: Layout,
    routes: [
      {
        exact: true,
        path: "/administrador/dashboard",
        title:"Dashboard",
        component: lazy(() => import("./views/Dashboard")),

      },

      {
        exact: true,
        path: "/administrador/puntocarga",
        title:"Dashboard",
        component: lazy(() => import("./views/Electrolinera/Index")),
      },
    
      {
        exact: true,
        path: "/administrador/marcas",
        title:"Marcas",
        component: lazy(() => import("./views/Marcas/Index")),
      },
      {
        exact: true,
        path: "/administrador/modelos/:idMarca",
        title:"Modelos",
        component: lazy(() => import("./views/Modelo/Index")),
      },
      {
        exact: true,
        path: "/administrador/detalle/:idDevice",
        title:"Detalle",
        component: lazy(() => import("./views/Detalle/Index")),
      },
      {
        exact: true,
        path: "/administrador/parametros",
        title:"Parámetros",
        component: lazy(() => import("./views/Parametros/Index")),
      },
      {
        exact: true,
        path: "/administrador/suscripciones",
        title:"Parámetros",
        component: lazy(() => import("./views/Suscripciones/Index")),
      },
      {
        exact: true,
        path: "/administrador/detallesuscripcion/:idParametro",
        title:"Detalle",
        component: lazy(() => import("./views/DetalleSuscripcion/Index")),
      },
      
      {
        exact: true,
        path: "/administrador/detalle-parametro/:idParametro",
        title:"Detalle",
        component: lazy(() => import("./views/DetalleParametro/Index")),
      },
      {
        exact: true,
        path: "/administrador/tipo-documento",
        title:"Tipo documento",
        component: lazy(() => import("./views/TipoDocumento/Index")),
      },
      {
        exact: true,
        path: "/administrador/usuarios-externos",
        title:"Tipo documento",
        component: lazy(() => import("./views/UsuariosExternos/Index")),
      },

      {
        exact: true,
        path: "/administrador/generador",
        title:"Tipo documento",
        component: lazy(() => import("./views/Generador/Index")),
      },
      {
        exact: true,
        path: "/administrador/monitoreo",
        title:"Tipo documento",
        component: lazy(() => import("./views/Monitoreo/Index")),
      },
      {
        exact: true,
        path: "/administrador/roles",
        title:"Roles",
        component: lazy(() => import("./views/Roles/Index")),
      },
      {
        exact: true,
        path: "/administrador/biblioteca",
        title:"Roles",
        component: lazy(() => import("./views/Biblioteca/Index")),
      },
      {
        exact: true,
        path: "/administrador/usuarios",
        title:"Usuarios",
        component: lazy(() => import("./views/Usuarios/Index")),
      },
      {
        exact: true,
        path: "/administrador/socios",
        title:"Usuarios",
        component: lazy(() => import("./views/UsuariosSocios/Index")),
      },
      {
        exact: true,
        path: "/administrador/empresas",
        title:"Empresas",
        component: lazy(() => import("./views/UsuariosEmpresa/Index")),
      },
      {
        exact: true,
        path: "/administrador/status",
        title:"Status",
        component: lazy(() => import("./views/Status/Index")),
      },
      {
        exact: true,
        path: "/administrador/qrgenerador",
        title:"Status",
        component: lazy(() => import("./views/QrGenerador")),
      },
      {
        exact: true,
        path: "/administrador/vehiculo/:idPersona",
        title:"Detalle",
        component: lazy(() => import("./views/Vehiculo/Index")),
      },
      {
        exact: true,
        path: "/administrador/vehiculo-user/:idPersona",
        title:"Detalle",
        component: lazy(() => import("./views/VehiculoUser/Index")),
      },
      {
        exact: true,
        path: "/administrador/detail-parameter-user",
        title:"Detalle",
        component: lazy(() => import("./views/DetalleParametroUser/Index")),
      },
      {
        exact: true,
        path: "/administrador/historial/:idVehiculo",
        title:"Detalle",
        component: lazy(() => import("./views/HistorialSubscripcion/Index")),
      },
      
    ],
  },
  
];

export default routes;
